import { useEffect, useState } from 'react'

import classnames from 'classnames'

import type { CtaProps } from '~/components/atoms/Ctas/Ctas'
import Ctas from '~/components/atoms/Ctas/Ctas'
import { ComponentTheme } from '~/components/themes'
import { useMediaQuery } from '~/services/useMediaQuery'
import bp from '~/styles/breakpoints/breakpoints'

import Container, { gutterTypes } from '../Container/Container'
import Fixture from '../Fixture/Fixture'
import { Col, Grid, Row } from '../Grid'
import type { ImageProps } from '../Image/Image'
import Image from '../Image/Image'
import Text, { TextSizes } from '../Text/Text'

import styles from './InListingBanner.module.css'

export interface InListingBannerProps {
  banners: {
    image: ImageProps
    title: string
    altText?: string
    ctas: CtaProps[]
  }[]
  theme?: ComponentTheme
  testID?: string
}

export default function InListingBanner({
  banners,
  theme = ComponentTheme.black,
  testID,
}: InListingBannerProps) {
  const [activeSlide, setActiveSlide] = useState<number>(0)
  const isMobile = useMediaQuery(`(max-width: ${bp.bpMedium})`)

  useEffect(() => {
    const interval = setInterval(() => {
      if (activeSlide < banners.length - 1) setActiveSlide(prev => prev + 1)
      else setActiveSlide(0)
    }, 5000)

    return () => {
      clearInterval(interval)
    }
  }, [activeSlide])

  return (
    <Fixture theme={theme} verticalPadding={true}>
      <Container gutters={gutterTypes.always}>
        <div className={styles.base} data-testid={testID}>
          {banners.map((banner, idx) => {
            return (
              <div
                className={classnames(
                  styles.slide,
                  activeSlide === idx && styles.slideActive
                )}
                key={idx}
              >
                <Grid>
                  <Row>
                    <Col variant="col-1/2--md">
                      <Text
                        size={
                          !isMobile
                            ? TextSizes.magPrimaryTitleXLrg
                            : TextSizes.magPrimaryTitleMed
                        }
                        className={styles.title}
                        Tag="h4"
                      >
                        <span
                          dangerouslySetInnerHTML={{ __html: banner.title }}
                        ></span>
                      </Text>
                      {!isMobile && banner.ctas && (
                        <Ctas ctas={banner.ctas} theme={theme} />
                      )}
                    </Col>
                    <Col variant="col-1/2--md">
                      <div className={styles.imageRatio}>
                        <Image {...banner.image} />
                      </div>
                      {isMobile && banner.ctas && (
                        <Ctas ctas={banner.ctas} theme={theme} />
                      )}
                    </Col>
                  </Row>
                </Grid>
              </div>
            )
          })}
        </div>
      </Container>
    </Fixture>
  )
}
